import { BikeIcon } from './BikeIcon';

/**
 * author: Google
 * id 627C7FF1-BCAD-4741-966E-7CED73B35DC2
 * name bike
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bike.svg
 * tags
 * - Transportation + Other 
 * - Sport 
 */
export const DirectionsBikeIcon = BikeIcon;
export default DirectionsBikeIcon